import { API } from 'aws-amplify';
import { useState } from "react";
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import { addDays } from 'date-fns';
import { getAuthToken } from "../../utils/AuthUtils";

import { EXPORTED_DATA_REPORT_HEADERS } from '../../Constants';

const UsageReportTab = () => {
    const [startDateString, setStartDateString] = useState("");
    const [endDateString, setEndDateString] = useState("");
    const [errorAlertStatus, setErrorAlertStatus] = useState(false)
    const [successAlertStatus, setSuccessAlertStatus] = useState(false)
    const [error, setError] = useState('')
    const [loadingStatus, setLoadingStatus] = useState(false)

    const clearMessage = () => {
        setError('');
        setErrorAlertStatus(false);
        setSuccessAlertStatus(false);
    }

    const createDateAndAddOneDay = (dateString) => {
        const date = new Date(dateString);
        date.setDate(date.getDate() + 1);
        return date;
    }

    // format the date to be in the format of YYYY-MM-DD
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const retrieveMetaData = async (e) => {
        clearMessage();
        e.preventDefault();
        if (startDateString === null
            || endDateString === null
            || startDateString === undefined
            || endDateString === undefined) {
            setError('Please select a date range');
            setErrorAlertStatus(true);
            return;
        }

        const startDate = createDateAndAddOneDay(startDateString);
        const endDate = createDateAndAddOneDay(endDateString);

        if (startDate > endDate) {
            setError('Start Date has to be more than End Date');
            setErrorAlertStatus(true);
            return;
        }
        setLoadingStatus(true);
        const authToken = await getAuthToken();

        const startingDateString = formatDate(startDate);
        const endingDateString = formatDate(endDate);

        API.get(
            "AnnualCompensations",
            "/bulk-usage-data?startingDate=" + startingDateString + "&endingDate=" + endingDateString,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Token": authToken
                }
            }).then(response => {
                exportDataToCsv(response.data);
                setLoadingStatus(false);
                setSuccessAlertStatus(true)
            }).catch(error => {
                if (error?.response?.data?.message) {
                    setError(error.response.data.message);
                    setErrorAlertStatus(true);
                } else {
                    setError("An error occurred while retrieving monthly usage data. Please try again later.");
                    setErrorAlertStatus(true);
                }
                setErrorAlertStatus(true);
                setLoadingStatus(false);
            })
    }

    const exportDataToCsv = async (exportedData) => {
        const rows = exportedData.map(row => ({
            downloader: row.email,
            templateName: row.templateName,
            companiesDowloaded: row?.numberOfCompaniesAccessed,
            clientOwnerName: row.clientOwnerName,
            clientOwnerEmail: row.clientOwnerEmail,
            billableType: row.billableType,
            clientToBill: row.clientName,
            // add 1 day to the date to account for the fact that the yyyy-MM-dd format needs to be converted to a Date object
            dateDownloaded: addDays(new Date(row.fullDateAccessed), 1),
            totalRecords: row?.numberOfRecordsAccessed,
            userNotes: row.userNotes,
            adminNotes: row.adminNotes,
            negotiatedRate: row?.negotiatedRate,
            isSubscriber: row?.isSubscriber
        }));

        const XLSX = await import('xlsx');

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Data Usage Report");

        XLSX.utils.sheet_add_aoa(worksheet,
            [EXPORTED_DATA_REPORT_HEADERS],
            { origin: "A1" });

        XLSX.writeFile(workbook, "Monthly_Usage_Report.xlsx");
    }

    return (
        <Form onSubmit={retrieveMetaData} style={{ margin: "1rem" }}>
            <Row>
                <Col md={6}>
                    <Form.Group controlId="startMonth" >
                        <Form.Label>Starting Month:</Form.Label>
                        <Form.Control
                            type="date"
                            value={startDateString}
                            onChange={(e) => setStartDateString(e.target.value)} />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group controlId="endMonth" >
                        <Form.Label>Ending Month:</Form.Label>
                        <Form.Control
                            type="date"
                            value={endDateString.toLocaleString('default', { month: 'long', year: 'numeric' })}
                            onChange={(e) => setEndDateString(e.target.value)} />
                    </Form.Group>
                </Col>
            </Row>
            {errorAlertStatus && <Row style={{ "marginTop": "0.5rem", "padding": "0 1rem" }}>
                <Alert variant="danger" onClose={() => setErrorAlertStatus(false)} style={{ "marginBottom": "0.3rem" }} dismissible>
                    <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                    <p>
                        {error}
                    </p>
                </Alert>
            </Row>}
            {successAlertStatus && <Row style={{ "marginTop": "0.5rem", "padding": "0 1rem" }}>
                <Alert variant="success" onClose={() => setSuccessAlertStatus(false)} style={{ "padding": "0.5rem", "marginBottom": "0.3rem" }} dismissible>
                    <Alert.Heading>Success!</Alert.Heading>
                </Alert>
            </Row>}
            <Row style={{ "marginTop": "0.5rem" }}>
                <Col>
                    <Button type='submit' style={{ "padding": "0.5rem" }} disabled={loadingStatus} variant='primary'>Submit</Button>
                </Col>
            </Row>
        </Form>
    )
}

export default UsageReportTab;